import React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { alpha } from "@mui/material/styles";

export default function EditModeClearFieldButton({ onClear }) {
  return (
    <IconButton
      size="small"
      onClick={onClear}
      sx={{
        padding: "4px",
        color: "primary.main",
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
        borderRadius: "6px",
        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.16),
        },
      }}
    >
      <CloseIcon sx={{ fontSize: "0.9rem" }} />
    </IconButton>
  );
}

EditModeClearFieldButton.propTypes = {
  onClear: PropTypes.func.isRequired,
};
